module.exports = __webpack_public_path__ + "img/entree-cagots-h900.18c1b259.jpg";